import {
  getEditOrderRedirect,
  canEditOrder,
  getRowLink,
} from '@ldt/api/order_loader/ancillary_lab';
import {
  checkOrderValidationErrors,
  getAvailableActions,
  getOrderMissingInfoMessages,
} from '@ldt/features/orders/components/order_actions/ancillary_lab';
import {
  getOrderListColumns,
  orderListSearchConfig,
} from '@ldt/features/orders/order_list/ancillary_lab';
import { getStatusFilterOptions } from '@ldt/features/orders/statuses/ancillary_lab';
import { getDefaultWorkflowOrderStatusName } from '@ldt/features/orders/statuses/workflow_shared';
import type { LdtWorkflowDefinition } from '@ldt/workflows/types';
import { SpecimenType } from 'src/types';

export const ancillaryLabWorkflow: LdtWorkflowDefinition = {
  canCreateOrder: false,
  showBillingHoldSection: false,
  showOrderingProviderSection: () => true,
  revertStatusOnSaveWithReport: false,
  orderListSearchConfig,
  supportedSpecimenTypes: new Set([
    SpecimenType.ProstateBiopsy,
    SpecimenType.MetastaticProstateBiopsy,
  ]),
  canEditOrder,
  getRowLink,
  getStatusDisplayName: getDefaultWorkflowOrderStatusName,
  getStatusFilterOptions,
  getEditOrderRedirect,
  getAvailableActions,
  getOrderMissingInfoMessages,
  checkOrderValidationErrors,
  getOrderListColumns,
};
